import React from 'react';
import { BaseComponent } from '../../../../components/BaseComponent';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../components/Box';
import { CompanyCreateField } from './Fields';
import { selectConfig, selectWork, selectWorks } from '../../../Api/selectors';
import { REQUEST_COMPANY, REQUEST_VIES_CHECK } from '../../constants';
import { createCompany, fetchCompanyViesChecksHistory } from '../../actions';
import { selectNewCompany } from '../../selectors';
import { Loader } from '../../../../components/Loader';
import { checkVies } from '../../actions';
import { BTW_COUNTRIES, REQUEST_VIES_CHECK_HISTORY } from '../../constants';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';
import { ViesCheckHistoryTable } from '../../components/ViesCheckHistoryTable1';
import cn from 'classnames';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import styles from './SecondStep.module.css';

const Container = styled.div`
  width: 100%;
  .cols {
  }
  .col {
    min-width: 400px;
    padding-right: 48px;
    @media (max-width: 768px) {
      width: 100%;
      min-width: 250px;
    }
  }

  .info-card {
    padding: 24px;
    width: auto;
    h2 {
      margin-bottom: 24px;
    }
    .btn {
      margin: 6px;
    }
    .col {
      @media (max-width: 768px) {
        width: 100%;
        min-width: 200px;
      }
    }
  }

  .vies-block {
    overflow-y: auto;
    width: 100%;
    max-height: 250px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
  }

  .button-block {
    margin: -6px;
    margin-right: 15px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: row;

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
`;

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class CompanyCreateStep2Comp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.company_id &&
      this.props.fetchViesHistory(result => {
        if (result?.items) {
          const logs = result?.items
            ?.filter(item => item?.actionType === 'vies_checked')
            ?.map(log => JSON.parse(log?.payload));
          this.setState({ viesHistory: logs });
        }
      });
  }

  get company() {
    return this.props.company;
  }

  get finDataTypes() {
    let types = ['IBAN', 'second_iban', 'BIC'];

    if (this.props.values.second_iban === '1') {
      types = ['IBAN', 'second_iban', 'IBAN2', 'BIC'];
    }

    return types;
  }

  create() {
    this.props.create(this.properties, this.options, result => {
      this.to(`/vehicles/${result.id}`);
    });
  }

  save() {
    this.props.onSave();
  }

  prevStep() {
    this.props.getPrevStep();
  }

  onViesCheck(event) {
    let options = BTW_COUNTRIES.map(c => ({ value: c.code, label: `${c.code}-${c.country}` }));
    const isWithCode = options.find(o => this.props.values?.BTW_number?.includes(o.value));
    let dto = {};
    if (isWithCode?.value) {
      dto = {
        id: this.props.company_id,
        entity: 'company',
        countryCode: isWithCode?.value,
        vatCode: this.props.values?.BTW_number?.substring(2),
      };
      return this.props.checkViesStatus(dto, result => {
        if (result) {
          this.props.fetchViesHistory(res => {
            if (res?.items) {
              const logs = res?.items
                ?.filter(item => item?.actionType === 'vies_checked')
                .map(log => JSON.parse(log?.payload));
              this.setState({ viesHistory: logs });
            }
          });
        }
      });
    }
    return;
  }

  renderViesHistoryBlock() {
    if (this.props.workViesHistory || this.props.workViesCheck) return <Loader small />;
    return (
      <HBox className="vies-block">
        <VBox>
          <ViesCheckHistoryTable historyLogs={this.state.viesHistory} />
        </VBox>
      </HBox>
    );
  }

  render() {
    if (this.props.work) return <Loader small />;

    return (
      <Container className={styles.container}>
        <HBox left className={styles.titleCompany}>
          <h5>{this.props.values.name}</h5>
        </HBox>
        <VBox className={cn('cols', styles.containerCol)}>
          <div className={cn('container-fluid info-card text-muted', styles.containerForm)}>
            <Wrapper className={styles.wrapper}>
              <div className={styles.containerFlex}>
                {['invoice_to_main_address'].map(type => (
                  <CompanyCreateField company_id={this.props.company_id} key={type} type={type} />
                ))}
                {this.props.values.invoice_to_main_address !== '1' && (
                  <>
                    {['addressLine1'].map(type => (
                      <CompanyCreateField company_id={this.props.company_id} key={type} type={type} />
                    ))}

                    {['postcode', 'city', 'countryId'].map(type => (
                      <CompanyCreateField company_id={this.props.company_id} key={type} type={type} />
                    ))}
                  </>
                )}
                {this.finDataTypes.map(type => (
                  <CompanyCreateField company_id={this.props.company_id} key={type} type={type} />
                ))}
                {['currency'].map(type => (
                  <CompanyCreateField company_id={this.props.company_id} key={type} type={type} />
                ))}
                {this.props.values.company_type === 'company' && (
                  <>
                    {this.lbl(`vehicle.property.BTW_number`)}

                    {['BTW_number'].map(type => (
                      <CompanyCreateField company_id={this.props.company_id} key={type} type={type} />
                    ))}
                    <div className="mt-2 mb-2">
                      <ButtonComponent
                        style="ButtonSoftPrimary"
                        disabled={this.props.workViesHistory || this.props.workViesCheck}
                        onClick={this.onViesCheck.bind(this)}
                      >
                        Vies check
                      </ButtonComponent>
                    </div>
                    {this.renderViesHistoryBlock()}
                  </>
                )}
              </div>
              <div className={styles.containerFlex}>
                {env.clientId === AppClientId.INDEWAL && (
                  <CompanyCreateField
                    company_id={this.props.company_id}
                    key="vindat_paymenttype"
                    type="vindat_paymenttype"
                  />
                )}
                {env.clientId === AppClientId.INDEWAL && (
                  <CompanyCreateField
                    company_id={this.props.company_id}
                    key="vindat_paymentcondition"
                    type="vindat_paymentcondition"
                  />
                )}
                {env.clientId === AppClientId.INDEWAL && (
                  <CompanyCreateField company_id={this.props.company_id} key="payment_term" type="payment_term" />
                )}
                {env.clientId === AppClientId.INDEWAL && (
                  <CompanyCreateField company_id={this.props.company_id} key="credit_limit" type="credit_limit" />
                )}
                {env.clientId === AppClientId.INDEWAL && (
                  <CompanyCreateField
                    company_id={this.props.company_id}
                    key="purchase_payment_term"
                    type="purchase_payment_term"
                  />
                )}
                {[
                  //  'vindat_paymenttype',
                  // 'vindat_paymentcondition',
                  // 'purchase_payment_term',
                  // 'payment_term',
                  // 'credit_limit',

                  'customernumber',
                  'company_from_eu',
                  // 'autoscoutURL',
                ].map(type => (
                  <CompanyCreateField company_id={this.props.company_id} key={type} type={type} />
                ))}
                {this.props.values.company_from_eu === 'OUTSIDE_EU' && (
                  <>
                    {['bordercross'].map(type => (
                      <CompanyCreateField company_id={this.props.company_id} key={type} type={type} />
                    ))}
                  </>
                )}
              </div>

              <div className={styles.containerFlex}>
                {[
                  //  'vindat_paymenttype',
                  // 'vindat_paymentcondition',
                  // 'purchase_payment_term',
                  // 'payment_term',
                  // 'credit_limit',
                  // 'autotraderURL',
                  // 'autoscoutURL',
                ].map(type => (
                  <CompanyCreateField company_id={this.props.company_id} key={type} type={type} />
                ))}
              </div>
            </Wrapper>

            <div className={cn('d-flex gap-2 justify-content-end mt-2', styles.buttonContainerBottom)}>
              <ButtonComponent style="ButtonSoftPrimary" onClick={this.prevStep.bind(this)}>
                {this.lbl('previous')}
              </ButtonComponent>
              <ButtonComponent style="ButtonSoftEdit" onClick={this.save.bind(this)} small>
                {this.lbl('save')}
              </ButtonComponent>
            </div>
          </div>
        </VBox>
      </Container>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_COMPANY]),
    workViesHistory: selectWork(`${REQUEST_VIES_CHECK_HISTORY}-${ownProps.company_id}`),
    workViesCheck: selectWork(REQUEST_VIES_CHECK),
    values: selectNewCompany(),
    config: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    create(properties, options, callback) {
      dispatch(createCompany(properties, options, callback));
    },
    checkViesStatus(dto, callback) {
      dispatch(checkVies(dto, callback));
    },
    fetchViesHistory(callback) {
      dispatch(fetchCompanyViesChecksHistory(ownProps.company_id, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyCreateStep2 = compose(withConnect, withRouter)(CompanyCreateStep2Comp);
